import { Tooltip } from 'antd';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface PlayerTooltipProps {
  title: ReactNode;
  children: ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const PlayerTooltip = ({
  title,
  children,
  placement = 'top',
}: PlayerTooltipProps) => {
  const getContainer = (): HTMLElement => {
    return (document.fullscreenElement as HTMLElement) || document.body;
  };
  return (
    <Tooltip
      title={
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className='capitalize'
        >
          {title}
        </motion.div>
      }
      placement={placement}
      mouseEnterDelay={0.5}
      arrow={false}
      getPopupContainer={getContainer}
      mouseLeaveDelay={0}
      classNames={{
        root: 'z-50 relative global-tooltip',
        body: 'z-50 relative',
      }}
      styles={{
        body: {
          zIndex: 9999,
          borderRadius: 8,
          padding: '4px 8px -1px 8px',
          fontSize: 10,
          fontWeight: 500,
          backgroundColor: 'rgba(0, 0, 0, 0.60)',
          border: '1px solid #3C3B3E',
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default PlayerTooltip;
